var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sm-signature",on:{"click":_vm.change}},[_c('VueSignaturePad',{ref:"signaturePad",class:{
      'sm-signature__canvas': true,
      'empty': _vm.isEmpty
    },attrs:{"width":"100%","height":"220px"}}),_c('checkbox-block',{attrs:{"text":_vm.confirmText},model:{value:(_vm.confirmed),callback:function ($$v) {_vm.confirmed=$$v},expression:"confirmed"}}),(!_vm.confirmText.length || _vm.confirmed)?_c('btn-block',{class:{
      'sm-signature__save': true,
      'disabled': _vm.isEmpty
    },attrs:{"text":_vm.saveText},on:{"click":_vm.save}}):_vm._e(),(_vm.showUndo)?_c('btn-block',{class:'sm-signature__undo',attrs:{"type":'small',"text":'Undo'},on:{"click":_vm.undo}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }